import React from 'react';

import { Alert, Button, Stack, TextField } from '@mui/material';

import { PAYLOAD_BUILDER_PLACEHOLDERS } from '~/utils/societePayloadBuilder/placeholders';

import { SectionCard } from './SectionCard';

interface LoadPayloadSectionProps {
  loadJson: string;
  loadError: string | null;
  collapseKey?: number;
  onLoadJsonChange: (value: string) => void;
  onLoadPayload: () => void;
  onClearLoad: () => void;
  onUploadFile: (file: File) => void;
}

export default function LoadPayloadSection({
  loadJson,
  loadError,
  collapseKey,
  onLoadJsonChange,
  onLoadPayload,
  onClearLoad,
  onUploadFile,
}: LoadPayloadSectionProps) {
  return (
    <SectionCard
      title="Load existing payload"
      subtitle="Paste or upload JSON from an existing Lab flag."
      collapseKey={collapseKey}
    >
      <TextField
        label="Paste JSON"
        placeholder={PAYLOAD_BUILDER_PLACEHOLDERS.loadJson}
        multiline
        minRows={4}
        value={loadJson}
        onChange={(event) => onLoadJsonChange(event.target.value)}
        fullWidth
      />
      {loadError ? <Alert severity="error">{loadError}</Alert> : null}
      <Stack direction="row" spacing={1} flexWrap="wrap">
        <Button variant="contained" onClick={onLoadPayload}>
          Load
        </Button>
        <Button variant="outlined" component="label">
          Upload .json / .txt
          <input
            hidden
            type="file"
            accept=".json,.txt,application/json,text/plain"
            onChange={(event) => {
              const file = event.target.files?.[0];
              if (file) onUploadFile(file);
              event.target.value = '';
            }}
          />
        </Button>
        <Button variant="text" onClick={onClearLoad}>
          Clear
        </Button>
      </Stack>
    </SectionCard>
  );
}
